/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationRemoteSessionIssuerMigratePreflightSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type GetOrganizationRemoteSessionIssuerMigratePreflightRequest = {
  /**
   * The remote_session_issuer to migrate away from.
   */
  sourceId: string;
  /**
   * The remote_session_issuer to migrate onto.
   */
  targetId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type GetOrganizationRemoteSessionIssuerMigratePreflightSecurity$Outbound =
  {
    "session_header_Gram-Session"?: string | undefined;
    "apikey_header_Gram-Key"?: string | undefined;
  };

/** @internal */
export const GetOrganizationRemoteSessionIssuerMigratePreflightSecurity$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionIssuerMigratePreflightSecurity$Outbound,
    GetOrganizationRemoteSessionIssuerMigratePreflightSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function getOrganizationRemoteSessionIssuerMigratePreflightSecurityToJSON(
  getOrganizationRemoteSessionIssuerMigratePreflightSecurity:
    GetOrganizationRemoteSessionIssuerMigratePreflightSecurity,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionIssuerMigratePreflightSecurity$outboundSchema
      .parse(getOrganizationRemoteSessionIssuerMigratePreflightSecurity),
  );
}

/** @internal */
export type GetOrganizationRemoteSessionIssuerMigratePreflightRequest$Outbound =
  {
    source_id: string;
    target_id: string;
    "Gram-Session"?: string | undefined;
    "Gram-Key"?: string | undefined;
  };

/** @internal */
export const GetOrganizationRemoteSessionIssuerMigratePreflightRequest$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionIssuerMigratePreflightRequest$Outbound,
    GetOrganizationRemoteSessionIssuerMigratePreflightRequest
  > = z.pipe(
    z.object({
      sourceId: z.string(),
      targetId: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sourceId: "source_id",
        targetId: "target_id",
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function getOrganizationRemoteSessionIssuerMigratePreflightRequestToJSON(
  getOrganizationRemoteSessionIssuerMigratePreflightRequest:
    GetOrganizationRemoteSessionIssuerMigratePreflightRequest,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionIssuerMigratePreflightRequest$outboundSchema
      .parse(getOrganizationRemoteSessionIssuerMigratePreflightRequest),
  );
}
